import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants } from 'utils';
import { Redirect } from 'react-router-dom';

const Home = () => {
	const user = useSelector((state: RootState) => state.user);

	if (!user) {
		return <Redirect to="/login" />
	}
	else {
		switch(user?.level_id) {
			case Constants.LEVELS.ADMIN:
				return <Redirect to="/admin" />
			break;

			case Constants.LEVELS.AFFILIATE:
				if (user.affiliate_type == Constants.AFFILIATE_TYPES.CLINIC) {
					return <Redirect to="/clinic" />
				} else if (user.affiliate_type == Constants.AFFILIATE_TYPES.MEDIC) {
					return <Redirect to="/doctor" />
				} else {
					return <Redirect to="/business" />
				}
			break;

			case Constants.LEVELS.SELLER:
				return <Redirect to="/seller" />
			break;

			default:
				return <Redirect to="/profile" />
			break;
		}
	}
}

export default Home;